const utilResizing = {    
    async resizeBase64Img(base64, newWidth, newHeight) {
        const resizedBase64 = await new Promise((resolve) => {
            const img = new Image()
            img.src = base64
            img.onload = () => {
                const canvas = document.createElement('canvas')
                let width = img.width
                let height = img.height
    
                if (width > height) {
                    if (width > newWidth) {
                        height *= newWidth / width
                        width = newWidth
                    }
                } else {
                    if (height > newHeight) {
                        width *= newHeight / height
                        height = newHeight
                    }
                }
                canvas.width = width
                canvas.height = height
                const ctx = canvas.getContext('2d')
                ctx.drawImage(img, 0, 0, width, height)
                resolve(canvas.toDataURL()) 
            }
        });
        return resizedBase64;
    },

    async imageToBase64(url, callback) {
        const image = new Image();
        image.crossOrigin = 'Anonymous';
        image.onload = function () {
          const canvas = document.createElement('canvas');
          canvas.width = image.width;
          canvas.height = image.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(image, 0, 0);
          const base64 = canvas.toDataURL('image/png'); 
          callback(null, base64);
        };
        image.onerror = function () {
          callback(new Error('Não foi possível carregar a imagem.'));
        };
        image.src = url;
      }
}


export default utilResizing;